define('lib/backbone/Backbone.PodioEvents',['require','underscore','backbone','backbone-super','lib/Podio.Logger'],function(require) {

  var _ = require('underscore');
  var Backbone = require('backbone');
  require('backbone-super');

  var podioLogger = require('lib/Podio.Logger');

  return {
    _getBus: function() {
      return this.eventBus || (this.options && this.options.eventBus);
    },

    on: function(ev, callback, context) {
      var bus = this._getBus();

      if (bus) {
        bus.on(ev, callback, context);

        return this;
      } else {
        Backbone.Events.on.call(this, ev, callback, context);
        return this;
      }
    },

    once: function(ev, callback, context) {
      var bus = this._getBus();

      if (bus) {
        bus.once(ev, callback, context);

        return this;
      } else {
        Backbone.Events.once.call(this, ev, callback, context);
        return this;
      }
    },

    off: function() {
      var bus = this._getBus();

      if (bus) {
        bus.off.apply(this, _.toArray(arguments));
        return this;
      } else {
        Backbone.Events.off.apply(this, _.toArray(arguments));
        return this;
      }
    },

    bind: function() {
      this.on.apply(this, _.toArray(arguments));
    },

    unbind: function() {
      this.off.apply(this, _.toArray(arguments));
    },

    trigger : function(eventName) {
      var bus = this._getBus();

      if (bus) {
        bus.trigger.apply(bus, arguments);
        if (this.eventLogging) {
          podioLogger.log('triggering', eventName);
        }
        return this;
      } else {
        Backbone.Events.trigger.apply(this, arguments);
        return this;
      }
    }//,

    // stopListeningToEventBus: function() {
    //   var self = this;
    //   var bus = this.eventBus || (this.options && this.options.eventBus);
    //
    //   if (!bus) {
    //     return false;
    //   }
    //
    //   _.each(bus._events, function(listeners, ev) {
    //     _.each(listeners, function(listener) {
    //       if (listener.context === self) {
    //         bus.off(ev, listener.callback);
    //       }
    //     });
    //   });
    // }
  };

});

